<template>
  <div class="normalLogin">
    <div class="banner">
      <img class="logo" src="@/assets/images/login/logo.png"/>
    </div>
    <form class="form">
      <div :class="{'sectiontextTips': isPhone, 'textTips': !isPhone}">手机号</div>
      <div class="section">
        <input v-model="phone" type="tel" maxlength="11" @focus="isPhone=true"/>
      </div>
      <div :class="{'sectiontextTips': isCode, 'textTips': !isCode}">短信验证码</div>
      <div class="section">
        <input v-model="tel" type="tel" maxlength="6" @focus="isCode=true"/>
        <div :class="['sendBtn',isSend ? 'disabled' : '']" @click="sendCode">{{isSend ? sendNum + '秒后重发' : '短信验证'}}</div>
      </div>
      <div class="tip">温馨提示：未注册大方租车账号的手机号，登录时将自动注册，并且代表您同意
        <agreement style="display:inline"></agreement>
      </div>
      <div @click="login" class="loginBtn">登录</div>
    </form>
    <div class="bottomBox">
      <p class="bottomTip">共享租车连锁品牌</p>
      <div class="bottomAdd">
        <span>覆盖城市&nbsp;300+</span>
        <span>服务门店&nbsp;700+</span>
        <span>服务网点&nbsp;6000+</span>
      </div>
    </div>
    <div class="imgBox" v-if="showPhotoImg">
      <div class="mask" @click="showPhotoImg=false"></div>
      <div class="main">
        <p class="title">请输入验证码</p>
        <img class="photoImg" v-if="img" :src="img" @click="getImg"/>
        <input v-model="imgCode" type="tel" maxlength="5" class="imgCode"  @input="imgCodeInput"/>
        <div class="tips" v-if="imgCodeMsg">
          <img class="icon" src="@/assets/images/login/tipIcon.png"/>
          <span>{{imgCodeMsg}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { randonBase64ImgValidateCode, sendValidateCodeWithImgValidate, nomalLogin } from "@/utils/api";
import agreement from "@/components/agreement.vue";
import { apiMode, deviceType } from "@/utils/env";

export default {
  name: "normalLogin",
  data: function() {
    return {
      deviceType: deviceType,
      isPhone: false,
      isCode: false,
      canInputCode: false,
      showPhotoImg: false, //是否显示图片验证码弹窗
      key: 0,
      redirect_uri: "",
      need_openid: 0,
      sendNum: 60,
      isSend: false,
      img: "", //图形url
      phone: "",
      imgCode: "",
      tel: "",
      userID: 0,
      inviteType: 0,
      imgCodeTime: 0, //图片验证码延时验证时间
      imgCodeMsg: "", //图片验证码输入提示语

    };
  },
  watch: {
    phone (val) {
      this.phone = val.replace(/[^\d]/g,'')
    },
    imgCode () {
      this.imgCodeMsg = ''
    },
    tel (val) {
      this.tel = val.replace(/[^\d]/g,'');
        // let mobile = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[189])\d{8}$/;
      let mobile = /^(1[3-9])\d{9}$/;
      if (this.phone == "" || !mobile.test(this.phone)) {
        this.flexible.showToast({
          content: "手机号码有误！"
        });
        this.tel = ''
      }
      if( !this.canInputCode ){
        this.flexible.showToast({
          content: "请先获取验证码！"
        });
      }
    }
  },
  components: {
    agreement
  },
  created() {
    this.key = ~~this.$route.query.key || 0;
    this.userID = this.$route.query.userID || 0;
    this.inviteType = this.$route.query.inviteType || 0;
  },
  mounted() {
    this.redirect_uri = this.$route.query.redirect_uri;
    this.need_openid = ~~this.$route.query.need_openid;


  },
  methods: {
    sendCode() {
      if (this.isSend) {
        return;
      }
      this.getImg();
    },
    async getImg() {
      // let mobile = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
      let mobile = /^(1[0-9])\d{9}$/;
      if (this.phone == "") {
        this.flexible.showToast({
          content: "手机号不能为空！"
        });
        return;
      }
      if (!mobile.test(this.phone)) {
        this.flexible.showToast({
          content: "请输入正确的手机号！"
        });
        return;
      }
      let res = await randonBase64ImgValidateCode({
        data: {
          phone: this.phone
        }
      });
      if (res.Code === 100) {
        this.imgCode = "";
        this.imgCodeMsg = "";
        this.img = "data:image/png;base64," + res.Data;
        this.showPhotoImg = true;
      }
    },
    imgCodeInput(e) {
      //延时验证
      let delayTime = 500;
      if (this.imgCodeTime) {
        clearTimeout(this.imgCodeTime);
      }
      this.imgCodeTime = setTimeout(async () => {
        if (this.imgCode.length==5 ) {
          let res = await sendValidateCodeWithImgValidate({
            data: {
              phone: this.phone,
              imgCode: this.imgCode
            },
            showError: false
          });
          if (res.Code==100) {
            this.canInputCode = true;
            if (apiMode == "build") {
              this.flexible.showToast({
                type: "success",
                content: "短信发送成功！"
              });
            }
            this.showPhotoImg = false;
            this.isSend = true;
            this.sendNum = 60;
            this.timeID = setInterval(this.awaitSend.bind(this), 1000);
          } else {
            this.imgCodeMsg = res.Message;
          }
        }
      }, delayTime);
    },
    awaitSend() {
      this.sendNum = this.sendNum - 1;
      if (this.sendNum <= 0) {
        clearInterval(this.timeID);
        this.isSend = false;
        this.timeID = 0;
      }
    },
    //登录
    async login(e) {
      if( !this.phone ){
        this.flexible.showToast({
          content: "手机号不能为空！"
        });
        return
      }
      if( !this.tel  ){
        this.flexible.showToast({
          content: "验证码不能为空！"
        });
        return
      }
      let dataObj = {
        Key: this.phone, //手机号
        Value: this.tel, //手机验证码
        LoginType: 1,
        LoginApp: 1,
        AccountType: 4,
        SiteType: 255,
        OwnerShopID: 3,
        RefereeID: Number(this.userID),
        RegisterResourceType: Number(this.inviteType)
      };
      if (this.key) {
        Object.assign(dataObj, { OwnerShopID: this.key });
      }
      let descriptionObj = {
        AccountType: 1,
        ReferalID: this.openId
      };
      if (this.need_openid) {
        dataObj.Description = JSON.stringify(descriptionObj);
      }
      let res = await nomalLogin({
        data: dataObj
      });
      if (res.Code === 100) {
        localStorage.setItem("token", res.Message);
        if( this.deviceType==2.5 ){
          wx.miniProgram.reLaunch({url:"index"});
          wx.miniProgram.postMessage({ data: { type: 'login', token: res.Message} });
        } else {
          let that = this;
          that.flexible.showToast({
            type: "success ",
            content: "登录成功！",
            duration: 1000,
            success: function() {
              if (that.redirect_uri) {
                let path = that.redirect_uri.slice(
                  that.redirect_uri.lastIndexOf("/")
                );
                that.$router.replace({ path: path });
              } else {
                let type = res.Data ? 0 : 1;
                that.$router.replace({ name: "index", params: { type: type } });
              }
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped lang="scss" type="text/scss">
.normalLogin {
  background-color: #fff;
  min-height: 17rem;
  height: 100%;
  position: absolute;
  top: 0;
  .banner {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #fff;
    .logo {
      width: 100%;
      height: auto;
    }
  }
  .form {
    flex: 1;
    margin-top: 10px;
    padding: 20px 40px;
    box-sizing: border-box;
    background-color: #fff;
    .textTips {
      position: relative;
      left: 30px;
      top: 54px;
      color: #666;
      font-size: 25px;
    }
    .sectiontextTips {
      position: relative;
      left: 0;
      top: 0;
      color: #222;
      font-size: 25px;
      transition: 0.1s linear;
    }
    .section {
      position: relative;
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      box-sizing: border-box;
      input {
        padding-left: 30px;
        flex: 1;
        box-sizing: border-box;
        height: 80px;
        font-size: 28px;
        border-bottom: 1px solid #9f9f9f; /*no*/
        background-color: transparent;
      }
      .ico {
        position: absolute;
        top: 20px;
        left: 20px;
        width: 40px;
        height: 40px;
      }
      .img,
      .sendBtn {
        margin-left: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 80px;
        font-size: 28px;
      }
      .sendBtn {
        border: 2px solid;
        color: #027fff;
        font-size: 28px;
        border-radius: 40px;
      }
      .sendBtn.disabled {
        background-color: #f0f0f0;
        font-size: 28px;
      }
    }
    .column {
      flex-direction: column;
      justify-content: left !important;
    }
    .tip {
      padding: 30px 0px;
      box-sizing: border-box;
      font-size: 22px;
      letter-spacing: 2px;
      line-height: 36px;
    }
    .loginBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px auto 0;
      box-sizing: border-box;
      width: 100%;
      height: 95px;
      background-color: #027fff;
      color: #fff;
      border-radius: 45px;
      font-size: 28px;
    }
  }
  .bottomBox {
    position: absolute;
    bottom: 40px;
    width: 100%;
    padding: 0 40px;
    box-sizing: border-box;
    text-align: center;
    .bottomTip {
      font-size: 22px;
      color: #cecece;
      margin-bottom:15px;
    }
    .bottomAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      span {
        font-size: 22px;
        color: #cecece;
      }
    }
  }
  .imgBox {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .mask {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      height: 100%;
      background-color: #000;
      opacity: 0.7;
    }
    .main {
      position: relative;
      z-index: 1000;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 520px;
      height: 340px;
      background: #fff;
      border-radius: 8px;
      .title {
        font-size: 22px;
        color: #ff6600;
        padding: 30px;
      }
      .imgCode {
        border-bottom: 1px solid #9f9f9f; /*no*/
        height: 65px;
        padding-bottom: 10px;
        box-sizing: border-box;
        margin-top: 20px;
        width: 348px;
        letter-spacing: 45px;
        text-align: center;
        font-size: 40px;
        color: #020202;
      }
      .tips {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        img {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
        span {
          font-size: 22px;
          color: #ff6600;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/login.vue